import './crumbTrail.scss';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useLanguage } from 'context/languageContext';
import { useTranslate } from 'context/languageContext';
import useResponsive from 'hooks/useResponsive/useResponsive';

export default function CrumbTrail({ items }) {
  const t = useTranslate();
  const HOME = { name: t('lb_seo_title_inicio'), url: '/' };
  const currentLanguage = useLanguage();
  const formatName = (name) => ` » ${name}`;
  const formatNameInverse = (name) => ` « ${name}`;
  const responsive = useResponsive();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const PAGE_ID = searchParams.get('pageId');
  const faqCategory = searchParams.get('faqCategoryId');
  const faqId = searchParams.get('faqId');

  const formatUrl = (url) => {
    if (url?.lastIndexOf('/') > 0) return `/${currentLanguage}${url}`;
    if (url?.length > 1) return `/${currentLanguage}${url}`;
    return url;
  };

  if (responsive.isMobile) {
    let lastItem = [...items].pop();
    if (lastItem?.url && items?.length > 1) {
        if (PAGE_ID && lastItem?.url?.split('=')[1] === PAGE_ID) {
            //caso en que la pageId es la misma que la presenta en el crumbtrail
            if (items[0]?.url && items[0]?.url?.split('=')[1] === PAGE_ID) {
                //caso de ser la primera url la misma que la ultima, ir a inicio
                lastItem = {...lastItem, ...{url: '', onClick: () => {navigate(formatUrl(HOME.url));}}};
            } else {
                lastItem = {...lastItem, ...{onClick: items[0]?.onClick}};
            }
        } else if (faqCategory && !faqId) {
            //caso estar en la url de una catgeoría de faq
            lastItem = {...lastItem, ...{onClick: () => {navigate(`/${currentLanguage}${items[items.length - 2]?.url}`);}, url: ''}};
        } else if (!lastItem?.onClick && !faqId && !PAGE_ID) {
            //en caso de tener el anterior y no ser iguales
            if (items[items.length - 2]?.onClick && lastItem?.url !== items[0]?.url) {
                lastItem = {...lastItem, ...{url: '', onClick: items[items.length - 2]?.onClick}};
            } else {
                lastItem = {...lastItem, ...{url: '', onClick: () => {navigate(formatUrl(HOME.url));}}};
            } 
        }
    } else if (!lastItem?.url && !lastItem?.onClick && items?.length > 1) {
        //caso detalle de noticia
        lastItem = {...lastItem, ...{url: '', onClick: () => navigate(`/${currentLanguage}${items[items.length - 2]?.url}`)}};
    }
    
    
    return (
      <div className='crumb-trail-box'>
        {[lastItem].map((route, i) =>
          route.url && route.name ? (
            <Link
              key={`crumb-trail-item-${i}`}
              to={formatUrl(route.url)}
              onClick={() => route.onClick && route.onClick()}
            >
              {formatNameInverse(route?.name)}
            </Link>
          ) : (
            route?.name && (
              <span key={`crumb-trail-item-${i}`} onClick={() => route.onClick && route.onClick()}>
                {formatNameInverse(route?.name)}
              </span>
            )
          ),
        )}
      </div>
    );
  }

  return items?.length > 0 ? (
    <div className='crumb-trail-box'>
      <>
        <Link to={formatUrl(HOME.url)}>{HOME.name}</Link>
        {items.map((route, i) =>
          route.url && route.name ? (
            <Link
              key={`crumb-trail-item-${i}`}
              to={formatUrl(route.url)}
              onClick={() => route.onClick && route.onClick()}
            >
              {formatName(route?.name)}
            </Link>
          ) : (
            route?.name && (
              <span key={`crumb-trail-item-${i}`} onClick={() => route.onClick && route.onClick()}>
                {formatName(route?.name)}
              </span>
            )
          ),
        )}
      </>
    </div>
  ) : null;
}
